import { ICellRendererParams } from 'ag-grid-community';
import EllipsisText from '@cp/src/components/EllipsisText';
import { Button } from '@navi/web-ui/lib/primitives';
import cx from 'classnames';
import { Dispatch, SetStateAction } from 'react';
import styles from './index.module.scss';
import TableCellRenderer from '@cp/src/components/TableCellRenderer';

export const ALL_AGENTS_COLUMN_DEFS = (onEditAgentClick: Dispatch<SetStateAction<boolean>>) => [
  {
    field: 'name',
    headerName: 'User',
    minWidth: 180,
    cellRenderer: (params: ICellRendererParams) => {
      return (
        <TableCellRenderer
          value={params.value}
          toolTipContent={params.value}
          showToolTip={true}
          tooltipContentClass={styles.tooltipWrapper}
          ellipsisWrapperClass="cursor-pointer"
        />
      );
    }
  },
  {
    field: 'phoneNumber',
    headerName: 'Phone Number',
    Width: 140,
    cellRenderer: (params: ICellRendererParams) => {
      return <EllipsisText text={params.value} ellipsisWrapperClass="cursor-pointer" />;
    }
  },
  {
    field: 'emailAddress',
    headerName: 'Email',
    minWidth: 180,
    cellRenderer: (params: ICellRendererParams) => {
      return (
        <TableCellRenderer
          value={params.value}
          toolTipContent={params.value}
          showToolTip={true}
          tooltipContentClass={styles.tooltipWrapper}
          ellipsisWrapperClass="cursor-pointer"
        />
      );
    }
  },
  {
    field: 'roles',
    headerName: 'Role',
    cellRenderer: (params: ICellRendererParams) => {
      return (
        <TableCellRenderer
          value={params.value.length > 1 ? params.value.join(',') : params.value}
          toolTipContent={params.value.length > 1 ? params.value.join(', ') : params.value}
          showToolTip={true}
          tooltipContentClass={styles.tooltipWrapper}
          ellipsisWrapperClass="cursor-pointer"
        />
      );
    }
  },
  {
    field: 'reportingManagerName',
    headerName: 'Reporting Manager',
    minWidth: 160,
    cellRenderer: (params: ICellRendererParams) => {
      return (
        <TableCellRenderer
          value={params.value}
          toolTipContent={params.value}
          showToolTip={true}
          tooltipContentClass={styles.tooltipWrapper}
          ellipsisWrapperClass="cursor-pointer"
        />
      );
    }
  },
  {
    field: 'active',
    headerName: 'Status',
    cellRenderer: (params: ICellRendererParams) => {
      return (
        <EllipsisText
          ellipsisWrapperClass={cx(
            'rounded-md border border-solid px-[8px] py-[2px] cursor-pointer',
            params.value
              ? 'text-green-base border-[var(--navi-color-green-border)] bg-[var(--navi-color-green-bg)]'
              : 'text-orange-dark border-[var(--navi-color-orange-border)] bg-[var(--navi-color-orange-bg)]'
          )}
          text={params.value ? 'Active' : 'Inactive'}
        />
      );
    }
  },
  {
    field: 'actions',
    headerName: 'Actions',
    cellRenderer: (params: ICellRendererParams) => {
      return (
        <Button
          variant="text"
          className={'hover:underline'}
          onClick={e => {
            e.stopPropagation();
            onEditAgentClick(e);
          }}
        >
          Edit details
        </Button>
      );
    }
  }
];
